// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-bottom-10[data-v-33254867] {\n  margin-bottom: 10px;\n}\n.right[data-v-33254867] {\n  text-align: right;\n}\n.table-body[data-v-33254867] {\n  margin-top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
